import { ToastService } from './../../../../core/toast.service';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SendOrderSupportRequestService } from '../../services/send-order-support-request.service';
import { GetSupportRequestReasonsService } from '../../services/get-support-request-reasons.service';

@Component({
  selector: 'app-raise-support',
  templateUrl: './raise-support.component.html',
  styleUrls: ['./raise-support.component.scss']
})
export class RaiseSupportComponent implements OnInit {
  raiseSupportForm = this.fb.group({
    reason: [null, [Validators.required]],
    message: [null, [Validators.required]],
    attachments: [null, []],
    type: ['GENERAL', [Validators.required]]
  });
  supportRequestReasonsList:any[];
  filterSupportRequestReasonsList:any[];
  reasonFilterCtrl = this.fb.control('');
  constructor(
    private fb: FormBuilder,
    private _dialogRef: MatDialogRef<RaiseSupportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sendOrderSupportRequestService: SendOrderSupportRequestService,
    private toast: ToastService,
    private getSupportRequestReasonsService: GetSupportRequestReasonsService
  ) { }

  ngOnInit(): void {
    this.getSupportRequestReasonsService.getSupportRequestReasons().subscribe((supportRequestReasonsList: any[])=>{
      this.supportRequestReasonsList = supportRequestReasonsList;
      this.filterSupportRequestReasonsList = supportRequestReasonsList;
    })

    this.reasonFilterCtrl.valueChanges.subscribe(value => {
      console.log(value);
      this.filterSupportRequestReasonsList =
      this.supportRequestReasonsList.filter(single=>{
        return single.name.toLowerCase().startsWith(value.toLowerCase());
      });
    });
  }
  /* ------------------------------ CUSTOM-METHODS ----------------------------- */
  closeDialog(status: string) {
    // this._dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(status); }, 1000);
  }
  /* --------------------------------- Getters -------------------------------- */
  get reason() {
    return this.raiseSupportForm.get('reason');
  }
  get message() {
    return this.raiseSupportForm.get('message');
  }
  get attachments() {
    return this.raiseSupportForm.get('attachments');
  }
  get type() {
    return this.raiseSupportForm.get('type');
  }

  async sendOrderSupportRequest(){
    if(this.raiseSupportForm.invalid){
      this.toast.openSnackBar('Please enter valid details');
      return;
    }
    try {
      const orderSupportRequest = this.raiseSupportForm.value as any;
      await this.sendOrderSupportRequestService.sendOrderSupportRequest(orderSupportRequest);
      this.closeDialog('yes');
      this.toast.openSnackBar('Support request raised successfully');
    } catch(error){
      this.toast.openSnackBar('Unable to raise support request');
    }

  }

  trimMe(ac: AbstractControl){
    ac.setValue(ac.value.trim());
  }
}
